import { number, object, string } from "yup";
import { requiredFieldValidationMessage } from "../../../Forms/ValidationMessages";
import { yupGsdbValidation } from "../../../Forms/yupGsdbValidation";
import { nameOf } from "../../../Utils/nameOf";
import { Branch } from "../../Branch";

export const branchSchema = object().shape({
  Name: string().required(requiredFieldValidationMessage("Name")).default(""),
  BranchGsdb: yupGsdbValidation(nameOf<Branch>("BranchGsdb")),
  CountryId: number().notOneOf([null, 0], "Please choose a country"),
  ImcsCode: string().uppercase().max(2, "IMCS Code must be at most 2 characters").default(""),
});
